import { delay } from 'redux-saga';
import { put, select } from 'redux-saga/effects';

import * as actions from '../../actions';

import updateQuestionChoice from './updateQuestionChoice';

export default function*(action) {
  const surveysState = yield select(state => state.surveys);
  const authState = yield select(state => state.auth);

  if (
    action &&
    action.updateActiveQuestion &&
    action.api &&
    surveysState.activeFlow &&
    !surveysState.activeFlow.flows &&
    surveysState.activeFlow.id
  ) {
    const newSurveyStateActiveFlow = {
      question: { ...surveysState.activeFlow }
    };
    action.api(
      'updateQuestion',
      newSurveyStateActiveFlow,
      undefined,
      undefined,
      authState
    );
  }

  const newState = updateQuestionChoice(
    surveysState,
    action.flowId,
    action.choice,
    action.answerUpdate,
    action.fullQuestionSurveyUpdate
  );

  if (
    (action.saveUpdatedQuestion || action.fullQuestionSurveyUpdate) &&
    newState &&
    newState.newState &&
    newState.newState.activeFlow
  ) {
    action.api(
      'updateQuestion',
      { question: newState.newState.activeFlow },
      undefined,
      undefined,
      authState
    );

    if (action.fullQuestionSurveyUpdate) {
      const surveyUpdateContent = {
        survey: newState.newState.survey.id,
        content: newState.newState.survey.content
      };
      action.api(
        'updateSurvey',
        { variables: surveyUpdateContent },
        undefined,
        undefined,
        authState
      );
    }
  }

  yield put({ type: actions.SET_NEW_STATE, newState: newState.newState });

  // Answer text autosave
  yield delay(1000);
  if (
    action &&
    // action.answerUpdate &&
    action.api &&
    surveysState.activeFlow &&
    !surveysState.activeFlow.flows &&
    surveysState.activeFlow.id
  ) {
    const newSurveyStateActiveFlow = {
      question: { ...surveysState.activeFlow }
    };
    action.api(
      'updateQuestion',
      newSurveyStateActiveFlow,
      undefined,
      undefined,
      authState
    );
  }
}
